import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { TicketService } from 'src/app/services/ticket.service';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.scss']
})
export class TicketComponent implements OnInit {
  page = null;
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }
  dataSource: MatTableDataSource<any>;
  isActive = false;
  filterForm: UntypedFormGroup;
  loading: boolean = true;
  displayedColumns = ['number', 'issueType', 'title', 'created', 'lastModified', 'state', 'menu']; //'user','worker',

  ticketStates = [
    { value: "NEW", viewValue: "Neu" },
    { value: "PARKED", viewValue: "Zurückgestellt" },
    { value: "CLOSED", viewValue: "Geschlossen" },
  ]

  issueTypes = [
    { value: "BASIC", viewValue: "nicht definiert" },
    { value: "SIGN_UP", viewValue: "Kunde werden o. Tarif wechseln" },
    { value: "MEASURE", viewValue: "Zählerstand" },
    { value: "PART_PAYMENT", viewValue: "Abschlagsänderung" },
    { value: "BANK_DETAILS", viewValue: "Bankdatenänderung" },
    { value: "RELOCATION_V1", viewValue: "Ummeldung" },
    { value: "RELOCATION_V2", viewValue: "Ummeldung" },
    { value: "MASTERDATA", viewValue: "Stammdatenänderung" },
    { value: "PHOTOVOLTAICS", viewValue: "Photovoltaik" },
    { value: "PRINT_CARD", viewValue: "Kartendruck" },
    { value: "PROSPECT", viewValue: "Wechselprozess" },
    { value: "INQUIRY", viewValue: "Allgemeine Anfrage" }
  ]

  constructor(
    private ticketService: TicketService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute) {
    this.filterForm = this.fb.group({
      filterByIssueTypes: [null],
      filterByTicketStates: [null],
      searchTerm: ['']
    })

    let extras = this.router.getCurrentNavigation()?.extras?.state;
    if (extras) {
      this.filterForm.markAllAsTouched();
      this.filterForm.patchValue({
        searchTerm: extras?.searchTerm,
        filterByIssueTypes: extras?.filterByIssueTypes,
        filterByTicketStates: extras?.filterByTicketStates,
      })
    }

    this.route.queryParams.subscribe(params => {
      console.log(params)
      this.filterForm.markAllAsTouched();
      this.filterForm.patchValue({
        searchTerm: params?.searchTerm,
        filterByIssueTypes: params?.filterByIssueTypes?.split(','),
        filterByTicketStates: params?.filterByTicketStates?.split(',')
      })
      if (params?.page) {
        this.pageData.pageIndex = params?.page;
      }
      if (params?.size) {
        this.pageData.pageSize = params?.size;
      }
    })


  }

  ngOnInit() {
    this.ticketService.filterTickets(0, 12, this.filterForm.value.filterByIssueTypes, this.filterForm.value.filterByTicketStates, this.filterForm.value.searchTerm).subscribe((val: PagedResources<any>) => {
      console.log(val)
      this.page = val.page;
      this.dataSource = new MatTableDataSource(val.content);
      val.content.forEach(el => {
        el['parsed_summary'] = JSON.parse(el.summary);
      });
      this.loading = false;
    })


  }
  /**
   * Load the Page set by the parma
   * @param event 
   */
  loadPage(event?: PageEvent) {
    this.pageData.pageIndex = event.pageIndex;
    this.pageData.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }
  /**
   * Search fot the Page with the Filter
   * @param pageIndex 
   * @param pageSize 
   */
  search(pageIndex, pageSize) {
    this.ticketService.filterTickets(pageIndex, pageSize, this.filterForm.value.filterByIssueTypes, this.filterForm.value.filterByTicketStates, this.filterForm.value.searchTerm).subscribe((val: PagedResources<any>) => {
      this.page = val.page
      this.dataSource = new MatTableDataSource(val.content);
    })
  }
  /**
   * Filter the Tickets
   */
  filterTickets() {
    this.ticketService.filterTickets(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.filterByIssueTypes, this.filterForm.value.filterByTicketStates, this.filterForm.value.searchTerm).subscribe((val: PagedResources<any>) => {
      this.page = val.page
      this.dataSource = new MatTableDataSource(val.content);
    })
  }
  /**
   * Get the Ticket as an XLS
   * @param ticketID 
   */
  getTicketAsXLS(ticketID) {
    this.ticketService.getTicketAsXLS(ticketID).subscribe(fromXLS => {
      console.log(fromXLS)
      var a = document.createElement("a");
      const contentType = 'application/vnd.ms-excel';
      const blob = new Blob([fromXLS], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = ticketID;
      a.click();
      window.URL.revokeObjectURL(url);
    })

    // this.eventService.downloadReservationList(event).subscribe(bal => {

    // })

  }

  changeTicketState(ticket:any,newState:String){
    ticket.state = newState;

    this.ticketService.editTicketById(ticket.publicId,ticket).subscribe(edit => {
      console.log(edit)
    })
    
  }
}
